var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[(_vm.refShow)?_c('div',[_c('b-table',{attrs:{"stacked":"md","items":_vm.financialInformationList,"fields":_vm.fields,"head-row-variant":"success"}})],1):_c('div',{staticClass:"text-center"},[_c('span',{staticClass:"h3"},[_vm._v(_vm._s(_vm.$t('message_not_ref_prices')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }